export const CONFIRMED_GET_FREQUENCIES = "CONFIRMED_GET_FREQUENCIES";
export const CONFIRMED_CREATE_FREQUENCY = "CONFIRMED_CREATE_FREQUENCY";
export const CONFIRMED_DELETE_FREQUENCY = "CONFIRMED_DELETE_FREQUENCY";
export const CONFIRMED_EDIT_FREQUENCY = "CONFIRMED_EDIT_FREQUENCY";
